import Vue from "vue"

import can from "./can";

Vue.prototype.$can = can;
